// Canonical BeatCredsi Passport URL helpers.
// Brand domain is the permanent address producers share in IG bios, EPKs, etc.
// The app also serves passports on the current host (preview / production); 301
// redirect rules on the host map old usernames to new ones.

export const PASSPORT_BRAND_HOST = "beatcredsi.com";
export const PASSPORT_BRAND_ORIGIN = `https://${PASSPORT_BRAND_HOST}`;

export function brandPassportUrl(username) {
  if (!username) return "";
  return `${PASSPORT_BRAND_ORIGIN}/c/${username}`;
}

export function brandPassportDisplay(username) {
  if (!username) return "";
  return `${PASSPORT_BRAND_HOST}/c/${username}`;
}
